import { useIntl } from 'react-intl';

import qrCode from '../../../../assets/images/qr-code-eye.svg';
import { ReactComponent as AppStore } from '../../../../assets/images/mobile-markets/app-store.svg';
import { ReactComponent as GooglePlay } from '../../../../assets/images/mobile-markets/google-play.svg';
import { ReactComponent as RuStore } from '../../../../assets/images/mobile-markets/ru-store.svg';
import { useStyles } from './download-app.styles';
import { ExternalLinks } from '../../../../constants';

export const DownloadApp = (): JSX.Element => {
  const classes = useStyles();
  const intl = useIntl();

  return (
    <div className={classes.apps} data-testid='download-app'>
      <div className={classes.qrCode} data-testid='qr-code'>
        <img
          src={qrCode}
          alt={intl.formatMessage({ id: 'common.qrCode' })}
          width="124"
          height="124"
        />
      </div>
      <ul className={classes.stores}>
        <li>
          {/* Don't remove data-testid, it is used by Yandex Metrica */}
          <a href={ExternalLinks.mobileMarket} target='_blank' rel='noopener noreferrer' data-testid='appStore-link'>
            <AppStore className={classes.icon} />
          </a>
        </li>
        <li>
          {/* Don't remove data-testid, it is used by Yandex Metrica */}
          <a href={ExternalLinks.mobileMarket} target='_blank' rel='noopener noreferrer' data-testid='googlePlay-link'>
            <GooglePlay className={classes.icon} />
          </a>
        </li>
        <li>
          {/* Don't remove data-testid, it is used by Yandex Metrica */}
          <a href={ExternalLinks.ruStore} rel='noopener noreferrer' data-testid='ruStore-link'>
            <RuStore className={classes.icon} />
          </a>
        </li>
      </ul>
    </div>
  );
};
